import { observable } from 'mobx';

export class AdminNavigation {

    @observable public adminRoute: string = '/';
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/stores/AdminNavigation.ts